import React from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import loadable from '@loadable/component';

import { TESTIMONIALS, TEXT_CONTENT, CAROUSEL_OPTIONS } from './constants';

// Dynamically load OwlCarousel to avoid SSR issues
const OwlCarousel = loadable(() => import('react-owl-carousel'), {
  ssr: false,
});

export default function TourTestimonialSlider() {
  return (
    <section className="testimonial-slider">
      <div className="container">
        <div className="testimonial-header">
          <h2>{TEXT_CONTENT.title}</h2>
          <p>{TEXT_CONTENT.subtitle}</p>
        </div>

        <div className="testimonial-carousel">
          <OwlCarousel className="owl-theme" {...CAROUSEL_OPTIONS}>
            {TESTIMONIALS.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-content">
                  <div className="quote-text">"{testimonial.quote}"</div>
                  <div className="description-text">{testimonial.description}</div>
                </div>
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={testimonial.image || TEXT_CONTENT.placeholderImage} alt={testimonial.name} />
                  </div>
                  <div className="author-name">{testimonial.name}</div>
                </div>
              </div>
            ))}
          </OwlCarousel>

          <div className="testimonial-navigation">
            <div className="nav-arrows"></div>
            <div className="nav-dots"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
